import { Analytics } from 'common-frontend'
import emitter  from 'react-ab-test/lib/emitter'

export default class AnalyticsUtils {
  static currentPath() {
    return window.location.pathname;
  }

  static templateUpdated(email, title, description, titleType, descriptionType) {
    Analytics.track('Template Updated', {
      email,
      path: this.currentPath(),
      title,
      description,
      type: { title: titleType, description: descriptionType },
    })
  }

  static templateInstructionsViewed(email, template) {
    Analytics.track('Template Instructions Viewed', { email, path: this.currentPath(), template })
  }

  static customTemplateSelected(email, template) {
    Analytics.track('Custom Template Selected', { email, path: this.currentPath(), template })
  }

  static npsViewed() {
    Analytics.track('NPS Viewed', { path: this.currentPath() })
  }

  static npsDismissed() {
    Analytics.track('NPS Dismissed', { path: this.currentPath() })
  }

  static npsScored(score) {
    Analytics.track('NPS Scored', { path: this.currentPath(), score})
  }

  static installInstructionsViewed(dialog) {
    Analytics.track('Install Instructions Viewed', { dialog } )
  }

  static recommendedJobViewed(jobType) {
    Analytics.track('Recommended Job Viewed',
      { job_type: jobType, path: this.currentPath() })
  }

  static recommendedJobViewed(jobType) {
    Analytics.track('Recommended Job Viewed',
      { job_type: jobType, path: this.currentPath() })
  }

  static learnMoreButtonClicked(jobType) {
    Analytics.track("'Learn More' Button Clicked",
      { job_type: jobType, path: this.currentPath() })
  }

  static getItFixedButtonClicked(jobType, pageLocation) {
    Analytics.track("'Get It Fixed' Button Clicked",
      { job_type: jobType, path: this.currentPath(), page_location: pageLocation })
  }

  static feedbackViewed() {
    Analytics.track("Review Request Viewed", { path: this.currentPath() })
  }

  static feedbackYesClicked() {
    Analytics.track("'Yes' Button Clicked", { path: this.currentPath() })
  }

  static feedbackNotReallyClicked() {
    Analytics.track("'Not Really' Button Clicked", { path: this.currentPath() })
  }

  static feedbackOkaySureClicked(question) {
    Analytics.track("'Okay Sure' Button Clicked", { question, path: this.currentPath() })
  }

  static feedbackNoThanksClicked(question) {
    Analytics.track("'No Thanks' Button Clicked", { question, path: this.currentPath() })
  }

  static clickedAddStaffAccountLink() {
    Analytics.track("Add Staff Account Link Clicked", { path: this.currentPath() })
  }

  static viewedRecommendedTemplates() {
    Analytics.track("Recommended Templates Viewed", { path: this.currentPath() })
  }

  static supportOfferViewed(featureType) {
    Analytics.track("Support Offer Viewed", { type: featureType, path: this.currentPath() })
  }

  static supportOfferAnswered(featureType, answer) {
    Analytics.track("Support Offer Answered", { type: featureType, answer, path: this.currentPath() })
  }

  static checksSupportFormViewed(featureType) {
    Analytics.track("Checks Support Form Viewed", { type: featureType, path: this.currentPath() })
  }

  static checksSupportFormAnswered(featureType, answer) {
    Analytics.track("Checks Support Form Answered", { type: featureType, answer, path: this.currentPath() })
  }

  static errorViewed(email, error_type, event = "Error Viewed") {
    Analytics.track(event,
      { path: this.currentPath(), error_type,  email })
  }

  static searchConsoleErrorViewed(email, error_type) {
    this.errorViewed(email, error_type, "Search Console Error Viewed")
  }

  static startedGoogleAccountConnection(email) {
    Analytics.track("Started Google Account Connection", { path: this.currentPath(), email } )
  }

  static startedGoogleAccountReconnection(email) {
    Analytics.track("Started Google Account Re-Connection", { path: this.currentPath(), email } )
  }

  static clickedSetupSearchConsoleAccount(email) {
    Analytics.track("Clicked Setup Search Console Account", { path: this.currentPath(), email } )
  }

  static startedTrial(email) {
    Analytics.track("Started Trial", { email })
  }

  static onboardingFieldCompleted(email, key, content) {
    Analytics.track("Onboarding Field Completed", { path: this.currentPath(), email, key, content })
  }

  static onboardingStepCompleted(email) {
    Analytics.track("Onboarding Step Completed", { path: this.currentPath(), email })
  }

  static onboardingStepSkipped(email) {
    Analytics.track("Onboarding Step Skipped", { path: this.currentPath(), email })
  }

  static installedCode(email, type) {
    Analytics.track("Automatic Code Installed", { path: this.currentPath(), email, type })
  }

  static installCodeFailed(email, type) {
    Analytics.track("Code Install Failed", { page: this.currentPath(), email, type })
  }

  static upgradedCode(email) {
    Analytics.track("Upgraded Code", { path: this.currentPath(), email })
  }

  static upgradeCodeFailed(email) {
    Analytics.track("Upgrade Code Failed", { page: this.currentPath(), email })
  }

  static plusInstallRequested(shop, email) {
    const type = emitter.getActiveVariant('Install Include')

    Analytics.track('Plus Install Requested', { page: this.currentPath(), shop, email, type})
  }
}



// WEBPACK FOOTER //
// ./app/utils/AnalyticsUtils.js